import { Produktlinienname } from '@ps20/bff-models';

export const ENTSCHAEDIGUNGSGRENZE_STEP = 500;

export const roundToStep = (value: number, step: number): number => {
  if (!step) {
    return value;
  }
  return Math.ceil(value / step) * step;
};

export interface EntschaedigungsgrenzeRadForLinie {
  produktlinie: Produktlinienname;
  betrag: number | null;
  defaultwert: number | null;
  minInput: number | null;
  maxInput: number | null;
  schrittweite: number | null;
  available: boolean;
  vorbelegungFehler?: string | null;
}

export const clampEntschaedigungsgrenze = (
  betrag: number | null,
  minInput: number | null,
  maxInput: number | null,
): number | null => {
  if (betrag == null) {
    return null;
  }
  if (minInput != null && betrag < minInput) {
    return minInput;
  }
  if (maxInput != null && betrag > maxInput) {
    return maxInput;
  }
  return betrag;
};

export const isEntschaedigungsgrenzeValid = (
  betrag: number | null,
  minInput: number | null,
  maxInput: number | null,
): boolean => {
  if (betrag == null || minInput == null || maxInput == null) {
    return true;
  }
  return betrag >= minInput && betrag <= maxInput;
};

export const isEntschaedigungsgrenzeResetFromBff = (
  linie: Pick<EntschaedigungsgrenzeRadForLinie, 'betrag' | 'vorbelegungFehler'> | null | undefined,
): boolean => linie?.betrag === 0 && !!linie?.vorbelegungFehler;
